<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title mb-0">
            {{ activeLanguageTranslations?.title | translate}}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.title }}</div> -->
        <div class="static-content-paragraph">
          <!-- <b> {{ activeLanguageTranslations?.sggsProject }} </b> <br />
          {{ activeLanguageTranslations?.subTagLine }} -->
        </div>

        <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.theVision }}</div> -->
        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph1 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph2 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph3 }}<br/>
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph4 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph5_1 }}
          <a [href]="fetchLanguage() != 'en' ? 'info/panjabi/privacy-policy' : 'info/english/privacy-policy'" target="_blank" class=" view-more-link">{{ activeLanguageTranslations?.Link5 }}</a>
          {{ activeLanguageTranslations?.Paragraph5_2 }}
        </div>
         
        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph6 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph7 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph8 }}<br/>
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph9 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph10 }}<br/>
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph11 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph12_1 }}
          <a [href]="fetchLanguage() != 'en' ? 'info/panjabi/privacy-policy' : 'info/english/privacy-policy'" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.Link12_1 }}</a>
          {{ activeLanguageTranslations?.Paragraph12_2 }}
          <a [href]="fetchLanguage() != 'en' ? 'info/panjabi/privacy-policy' : 'info/english/privacy-policy'" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.Link12_2 }}</a>
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph13 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph14 }}<br/>
      
          <p class="left-padding pt-3">{{ activeLanguageTranslations?.Paragraph14_1 }}<br/></p>
          <p class="left-padding">{{ activeLanguageTranslations?.Paragraph14_2 }}<br/></p>
          <p class="left-padding">{{ activeLanguageTranslations?.Paragraph14_3 }}<br/></p>
          <p class="left-padding">{{ activeLanguageTranslations?.Paragraph14_4 }}<br/></p>
          <p class="left-padding">{{ activeLanguageTranslations?.Paragraph14_5 }}<br/><br/></p>
          {{ activeLanguageTranslations?.Paragraph15 }}<br/>
          <p class="left-padding pt-3">{{ activeLanguageTranslations?.Paragraph15_1 }}<br/></p>
          <p class="left-padding">{{ activeLanguageTranslations?.Paragraph15_2 }}<br/></p>
          <p class="left-padding">{{ activeLanguageTranslations?.Paragraph15_3 }}<br/></p>
          <p class="left-padding">{{ activeLanguageTranslations?.Paragraph15_4 }}<br/><br/></p>
          {{ activeLanguageTranslations?.Paragraph16 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph17 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph18 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph19 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph20 }}<br/><br/>
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph21 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph22 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph23 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph24 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph25 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph26 }}<br/>
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph27 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph28 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph29 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph30 }}<br/><br/>
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph31 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph32 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph33 }}<br/><br/>
          {{ activeLanguageTranslations?.Paragraph34 }}<br/><br/>
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph35 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph36 }}<br/>
        </div>
        
        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph37 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph38 }}<br/>
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph39 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph40 }}<br/>
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph41 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph42_1 }}
          <a [href]="fetchLanguage() != 'en' ? 'info/panjabi/privacy-policy' : 'info/english/privacy-policy'" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.Link42 }}</a>
          {{ activeLanguageTranslations?.Paragraph42_2 }}
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.Paragraph43 }}</b><br/><br/>
          {{ activeLanguageTranslations?.Paragraph44 }} <a class="know-more" href="mailto:{{activeLanguageTranslations?.maillink}} ">{{activeLanguageTranslations?.maillink}}. </a><br/>
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph45 }}<br/>
          <a href="{{ activeLanguageTranslations?.Link46  }}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.Link46 }}</a><br/>
          {{ activeLanguageTranslations?.Paragraph47 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph48 }}
        </div>


       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
